import { Extension } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    selectedText: {
      getSelectedText: () => ReturnType;
    };
  }
}

export default Extension.create({
  name: "SelectedText",
  //@ts-ignore
  addCommands() {
    return {
      getSelectedText:
        () =>
        ({ editor }) => {
          const { from, to, empty } = editor.state.selection;
          if (empty) {
            return "";
          }
          return editor.state.doc.textBetween(from, to, " ");
        },
    };
  },
});
